import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { useAppDispatch } from "@/store";
import { createOrganization } from "@/store/slices/organizationSlice";
import { useNotification } from "@/context/NotificationContext";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function CreateOrganizationDialog({ open, onClose }: Props) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { notify } = useNotification();
  const [name, setName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = async () => {
    try {
      await dispatch(
        createOrganization({
          name,
          displayName: displayName || undefined,
          description: description || undefined,
        }),
      ).unwrap();
      notify(t("org.createOrg") + " - OK", "success");
      setName("");
      setDisplayName("");
      setDescription("");
      onClose();
    } catch {
      notify(t("errors.generic"), "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("org.createOrg")}</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}
      >
        <TextField
          label={t("org.orgName")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          fullWidth
          margin="dense"
        />
        <TextField
          label={t("org.displayName")}
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          fullWidth
          margin="dense"
        />
        <TextField
          label={t("common.description")}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={3}
          fullWidth
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!name.trim()}
        >
          {t("common.create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
